import { render, staticRenderFns } from "./MSTEntryInsurerInformation.vue?vue&type=template&id=865f6220&scoped=true"
import script from "./MSTEntryInsurerInformation.vue?vue&type=script&lang=js"
export * from "./MSTEntryInsurerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865f6220",
  null
  
)

export default component.exports